<ng-container class = "icc-container">
  <h3 >{{ 'WINDOW|Edycja pakietu szybowego' | translate }}</h3>
  @if (!edit && resolve.fillingsProducers.length > 1) {
    <div>
      <label>{{ 'WINDOW|Producent' | translate }}</label>
      <mat-select
        [(ngModel)]="resolve.producerId"
        (ngModelChange)="changeGlazingUnit()"
        >
        @for (value of resolve.fillingsProducers; track value) {
          <mat-option>{{value.name}}</mat-option>
        }
      </mat-select>
    </div>
  }
  @if (!edit) {
    <div>
      <label>{{ 'WINDOW|Ilość szyb' | translate }}</label>
      <mat-select
        [ngModel]="glazingCount"
        (ngModelChange)="changeGlazingUnit()"
      ></mat-select>
    </div>
  }
  <h4>{{ 'WINDOW|Strona zewnętrzna' | translate }}</h4>
  @for (item of resolve.glazingUnit; track item) {
    <div>
      @if (item.type == 'glass') {
        <div class="windowPart">{{ 'WINDOW|Szyba' | translate }}</div>
      }
      @if (item.type == 'interPaneSpace') {
        <div class="windowPart">{{ 'WINDOW|Komora' | translate }}</div>
      }
      <mat-form-field>
        @if (item.type == 'glass' && resolve.glazingUnit.length == 1) {
          <mat-select
            [(ngModel)]="item.value"
            >
            @for (glass of resolve.glasses; track glass) {
              <mat-option [value]="glass.id">{{glass.name}}</mat-option>
            }
          </mat-select>
        }
        @if (item.type == 'glass' && item.position == 'outer' && resolve.glazingUnit.length > 1) {
          <mat-select
            [(ngModel)]="item.value"
            >
            @for (glass of outerGlasses; track glass) {
              <mat-option [value]="glass.id">{{glass.name}}</mat-option>
            }
          </mat-select>
        }
        @if (item.type == 'glass' && item.position == 'inner') {
          <mat-select
            [(ngModel)]="item.value"
            >
            @for (glass of innerGlasses; track glass) {
              <mat-option [value]="glass.id">{{glass.name}}</mat-option>
            }
          </mat-select>
        }
        @if (item.type == 'glass' && item.position == 'middle') {
          <mat-select
            [(ngModel)]="item.value"
            >
            @for (glass of middleGlasses; track glass) {
              <mat-option [value]="glass.id">{{glass.name}}</mat-option>
            }
          </mat-select>
        }
        @if (item.type == 'interPaneSpace') {
          <mat-select
            [(ngModel)]="item.value"
            >
            @for (glass of interPaneSpaces; track glass) {
              <mat-option [value]="glass.id">{{glass.name}}</mat-option>
            }
          </mat-select>
        }
      </mat-form-field>
    </div>
  }
  <h4>{{ 'WINDOW|Strona wewnętrzna' | translate }}</h4>
  <button mat-raised-button class="button" (click)="closeModal(true)" color="primary">{{ 'INTERFACE|OK' | translate }}</button>
</ng-container>
